import { api } from '../index';

export const getTransportCustomers = async () => {
  const response = await api.get(`/transport/customers`);
  return response?.data;
};

export const createTransportCustomer = async (customerData: {
  name: string;
  businessId: string;
  customerId?: string;
  discount: number;
}) => {
  const response = await api.post(
    `/transport/customers`,
    customerData,
  );
  return response?.data;
};

export const updateTransportCustomer = async (customerData: {
  id: number;
  name: string;
  businessId: string;
  customerId?: string;
  discount: number;
}) => {
  const response = await api.put(
    `/transport/customers/${customerData.id}`,
    customerData,
  );
  return response?.data;
};

export const upsertTransportCustomersBatch = async (
  customersData: Array<{
    id?: number;
    name: string;
    businessId: string;
    customerId?: string | null;
    discount: number;
  }>,
) => {
  const response = await api.put(
    `/transport/customers`,
    customersData,
  );
  return response?.data;
};

export const deleteTransportCustomer = async (id: string) => {
  const response = await api.delete(`/transport/customers/${id}`);
  return response?.data;
};

export const deleteTransportCustomersBatch = async (
  ids: number[],
) => {
  const response = await api.post(
    `/transport/customers/batch-delete`,
    {
      ids,
    },
  );
  return response?.data;
};
